import { Formik } from "formik";
import moment from "moment";
import React from "react";
import { FormControl } from "@mui/material";
import { DatePicker } from "rsuite";
import { useSelector } from "react-redux";

const ReservationFilterByDate = (props) => {
  const selectedPlace = useSelector((state) => state.places?.selectedPlace);
  const placeId = selectedPlace?._id;
  const { filterOptions, setFilterOptions } = props;

  return (
    <>
      <Formik
        initialValues={{
          startDate: "",
          endDate: "",
        }}
        onSubmit={(values) => {
          setFilterOptions({
            ...filterOptions,
            pageNo: 0,
            ...values,
            placeId,
            tz: selectedPlace?.timeZoneId,
            startDate: moment(values.startDate).format("YYYY-MM-DD").toString(),
            endDate: moment(values.endDate).format("YYYY-MM-DD").toString(),
          });
        }}
      >
        {(props) => (
          <form onSubmit={props.handleSubmit}>
            <div style={{ display: "flex", gap: "1rem" }}>
              <FormControl fullWidth>
                <DatePicker
                  id="startDate"
                  placeholder="Start Date"
                  size="lg"
                  format="MM/dd/yyyy"
                  ranges={[]}
                  value={
                    props.values.startDate
                      ? new Date(props.values.startDate)
                      : null
                  }
                  onChange={(value) => {
                    props.setFieldValue(
                      "startDate",
                      value ? moment(value).format() : null
                    );
                    if (value && props.values.endDate) {
                      props.handleSubmit();
                    }
                  }}
                  onClean={() => {
                    props.setFieldValue("startDate", null);
                    setFilterOptions({
                      status: "all",
                      placeId,
                      startDate: "",
                      endDate: "",
                      search: "",
                    });
                  }}
                />
              </FormControl>
              <FormControl fullWidth>
                <DatePicker
                  id="endDate"
                  placeholder="End Date"
                  size="lg"
                  format="MM/dd/yyyy"
                  ranges={[]}
                  value={
                    props.values.endDate ? new Date(props.values.endDate) : null
                  }
                  onChange={(value) => {
                    props.setFieldValue(
                      "endDate",
                      value ? moment(value).format() : null
                    );
                    if (value && props.values.startDate) {
                      props.handleSubmit();
                    }
                  }}
                  onClean={() => {
                    props.setFieldValue("endDate", null);
                    setFilterOptions({
                      status: "all",
                      placeId,
                      startDate: "",
                      endDate: "",
                      search: "",
                    });
                  }}
                />
              </FormControl>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default ReservationFilterByDate;
